import React from "react";

const FormButton = ({
    onClick,
    text,
    icon,
    color = "primary",
    disabled = false,
    mb,
    className
}: {
    onClick?: (any) => any;
    text?: string;
    icon?: string;
    color?: "primary" | "secondary" | "success" | "danger" | "warning" | "info" | "light" | "dark";
    disabled?: boolean;
    mb?: number;
    className?: any;
}) => {
    return (
        <button className={`btn btn-outline-${color} ${mb ? 'mb-' + mb : ''} ${className!=undefined?className:''}`} type="button" onClick={onClick} disabled={disabled}>
            {text}
            {!text && <i className={`bi bi-${icon}`} />}
        </button>
    )
}

export default FormButton;